export default __webpack_public_path__ + "images/151801ebeef6276ea3e17ad326d55b5b.svg";